/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Scope_Teams_HintInputs */



/**
* | output |
* | --- |
* | "Only members of the teams you pick can see and run this agent." |
*
* @param {Agent_Builder_Scope_Teams_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_scope_teams_hint = /** @type {((inputs?: Agent_Builder_Scope_Teams_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Scope_Teams_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Mitglieder der ausgewählten Teams sehen und starten diesen Agenten.")
	return /** @type {LocalizedString} */ ("Only members of the teams you pick can see and run this agent.")
});